module.exports = __webpack_public_path__ + "media/nujabes-reflection-eternal-hd.d94cfa9f.mp3";